var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collection-layout-page',{attrs:{"collectionId":_vm.collectionId,"stateCache":_vm.stateCache}})}
var staticRenderFns = []

export { render, staticRenderFns }